<h1 mat-dialog-title>{{ 'properties.remappings.listTitle' | translate }}</h1>
<mat-dialog-content>
  <div class="row align-items-center mt-2 mb-3">
    <div class="col-12 col-sm-6 text-left">
      <button *ngIf="canCreate()" class="add-icon-button mr-2" color="primary" (click)="onAddRemapping()" mat-flat-button
        matTooltip="{{ 'properties.remappings.addBtn' | translate }}" matTooltipPosition="above">
        {{ 'properties.remappings.addBtn' | translate }}
      </button>
    </div>
    <div class="col-12 col-sm-6 text-right">
      <button mat-button (click)="onExport()" class="d-none d-sm-inline-block" *ngIf="canExport()">
        <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
        {{ 'common.words.export' | translate }}
      </button>
      <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
        <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
        {{ 'common.cta.resetFilters' | translate }}
      </button>
    </div>
  </div>

  <div class="table-wrapper">
    <div class="spinner-container" *ngIf="dataSource && dataSource.loading$ | async">
      <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc" matSortDisableClear
        class="mat-elevation-z0">
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'properties.remappings.cols.date' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.date | date: 'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="plant">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'properties.remappings.cols.plant' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ plantLabels[element.plant] ? plantLabels[element.plant] : element.plant }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'properties.remappings.cols.description' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>
        <!-- Column id and i18n key stay "mappingUser" (UI identity: "Mappatore"),
             but the value comes from the server-resolved createdBy author. -->
        <ng-container matColumnDef="mappingUser">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'properties.remappings.cols.mappingUser' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ getMapperName(element) }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-right pr-3">
            {{ 'properties.remappings.cols.actions' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-right">
            <button *ngIf="canCreate() || canDelete()" mat-flat-button color="primary" [matMenuTriggerFor]="rowMenu">
              {{ 'common.cta.open' | translate }}
              <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu">
              <button mat-menu-item *ngIf="canCreate()" (click)="onEditRemapping(element)">
                <mat-icon fontSet="fal" fontIcon="fa-edit"></mat-icon>
                <span>{{ 'properties.remappings.edit' | translate }}</span>
              </button>
              <button mat-menu-item *ngIf="canDelete()" (click)="onDeleteRemapping(element)">
                <mat-icon fontSet="fal" fontIcon="fa-trash"></mat-icon>
                <span>{{ 'properties.remappings.delete' | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" [class.even-row]="(i % 2) == 0"></tr>
      </table>
      <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div class="row mt-3 mb-1">
    <div class="col-12 text-right">
      <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div>
  </div>
</mat-dialog-content>
